"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _constant = require("./constant");
var _IDCard = _interopRequireDefault(require("./IDCard.proptypes"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "IDCard__StyledWrapper",
  componentId: "sc-12t7wuw-0"
})(["width:292px;max-height:180px;background:", ";border-radius:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return color ? theme.backgroundColor[color] : theme.backgroundColor.greyLighter;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.XSmall;
});
var StyledTitleContainer = _styledComponents.default.div.withConfig({
  displayName: "IDCard__StyledTitleContainer",
  componentId: "sc-12t7wuw-1"
})(["margin-bottom:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
});
var StyledBody = _styledComponents.default.div.withConfig({
  displayName: "IDCard__StyledBody",
  componentId: "sc-12t7wuw-2"
})(["display:flex;"]);
var StyledIconContainer = _styledComponents.default.div.withConfig({
  displayName: "IDCard__StyledIconContainer",
  componentId: "sc-12t7wuw-3"
})(["padding:", ";svg{font-size:8em !important;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.micro;
});
var StyledFieldContainer = _styledComponents.default.div.withConfig({
  displayName: "IDCard__StyledFieldContainer",
  componentId: "sc-12t7wuw-4"
})(["padding:", " 0;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.normal;
});
var StyledFieldRow = _styledComponents.default.div.withConfig({
  displayName: "IDCard__StyledFieldRow",
  componentId: "sc-12t7wuw-5"
})(["display:flex;flex-direction:column;margin-bottom:", ";& >:last-child{text-decoration:underline;text-underline-position:under;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.small;
});
var renderFieldContainer = function renderFieldContainer(label, value, accessible, theme) {
  return /*#__PURE__*/_react.default.createElement(StyledFieldRow, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.DISPLAY.inlineFlex,
    theme: theme,
    type: _constant.SIZES.small,
    color: _constant.COLORS.greyDarker,
    bold: true
  }, label), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.DISPLAY.inlineFlex,
    theme: theme,
    type: _constant.SIZES.default,
    color: _constant.COLORS.secondaryBlue,
    bold: true
  }, value));
};
var IDCard = function IDCard(_ref8) {
  var accessible = _ref8.accessible,
    theme = _ref8.theme,
    customProperties = _ref8.customProperties,
    translation = _ref8.translation,
    title = _ref8.title,
    icon = _ref8.icon,
    color = _ref8.color,
    fields = _ref8.fields;
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledWrapper, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties, {
    color: color
  }), /*#__PURE__*/_react.default.createElement(StyledTitleContainer, null, ' ', /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: true,
    display: _constant.DISPLAY.inlineFlex,
    theme: theme,
    type: _constant.SIZES.small,
    bold: true
  }, title || language.cardTitle)), /*#__PURE__*/_react.default.createElement(StyledBody, null, /*#__PURE__*/_react.default.createElement(StyledIconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: true,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.titleExtraLarge,
    icon: icon || _constant.ICON,
    theme: theme
  })), /*#__PURE__*/_react.default.createElement(StyledFieldContainer, null, (fields || _constant.FIELDS).map(function (field) {
    return renderFieldContainer(field.label, field.value, accessible, theme);
  })))));
};
IDCard.propTypes = _IDCard.default.PropTypes;
IDCard.defaultProps = _IDCard.default.DefaultProps;
var _default = IDCard;
exports.default = _default;